import { Component, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { AppSettingsService } from '../services/app-settings.service'
import { StorageService } from 'src/app/e-commerce/orders/storage-service/storage.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-seo-settings',
  templateUrl: './seo-settings.component.html',
  styleUrls: ['./seo-settings.component.scss']
})
export class SeoSettingsComponent implements OnInit {
  project_id: string
  seoSettingsData: any = {}
  allowSearchEngines: boolean = true

  seoSettingsForm = this.formBuilder.group({
    meta_title: '',
    meta_description: '',
    social_share_title: '',
    social_share_description: ''
  })

  constructor(
    private formBuilder: FormBuilder,
    private appSettingsService: AppSettingsService,
    public builderService: BuilderService,
    private storageService: StorageService,
  ) {
    this.builderService.showUpdateProgress = true
    this.project_id = this.builderService.selectedProject
    if (!this.project_id) {
      setTimeout(() => {
        this.getInitialSettings()
      }, 1000)
    } else {
      this.getInitialSettings()
    }
  }

  ngOnInit(): void {}

  getInitialSettings = () => {
    this.appSettingsService.getSeoSettings(this.project_id).subscribe(
      (settings: any) => {
        this.seoSettingsData = settings || {}
        if (settings) {
          this.seoSettingsForm.patchValue({
            meta_title: settings.meta_title || '',
            meta_description: settings.meta_description || '',
            social_share_title: settings.social_share_title || '',
            social_share_description: settings.social_share_description || ''
          })
          this.allowSearchEngines = settings.allow_search_engines ?? true
        }
        this.builderService.showUpdateProgress = false
      },
      (err: any) => {
        console.log(err)
        this.builderService.showUpdateProgress = false
      }
    )
  }

  onSubmit(): void {
    if (!this.isPremium) return
    this.builderService.showUpdateProgress = true
    const formValues = this.seoSettingsForm.value
    const submitData: any = {
      meta_title: formValues.meta_title || this.seoSettingsData.meta_title || '',
      meta_description: formValues.meta_description || this.seoSettingsData.meta_description || '',
      social_share_title: formValues.social_share_title || this.seoSettingsData.social_share_title || '',
      social_share_description: formValues.social_share_description || this.seoSettingsData.social_share_description || '',
      social_share_image: this.seoSettingsData.social_share_image || '',
      allow_search_engines: this.allowSearchEngines
    }

    this.appSettingsService.setSeoSettings(this.project_id, submitData).subscribe(
      () => {
        this.builderService.showUpdateProgress = false
      },
      (err: any) => {
        console.log(err)
        this.builderService.showUpdateProgress = false
      }
    )
  }


  processFile(imageInput: any): void {
    if (!this.isPremium) return
    const file: File = imageInput.target.files[0]
    if (!file) return

    this.builderService.showUpdateProgress = true
    const projectId = this.builderService.selectedProject
    const fileExtension = file.name.split('.').pop()
    const storagePath = `images/social_share_image.${fileExtension}`

    this.storageService.uploadFile(file, projectId, storagePath).then(
      (downloadURL) => {
        this.seoSettingsData.social_share_image = downloadURL
        this.builderService.showUpdateProgress = false
      },
      (_err: any) => {
        this.builderService.showUpdateProgress = false
        alert('Error uploading file, please contact support')
      }
    )
  }
  get isPremium(): boolean {
    return this.builderService.is_premium;
  }

  showUpgradeDialog(): void {
    const baseUrl = `${environment.stacksURL}pricing`
    const projectId = this.builderService.selectedProject
    const url = projectId ? `${baseUrl}?project_id=${encodeURIComponent(projectId)}` : baseUrl
    window.open(url, '_blank')
  }
}
